import {Layers, WalkOfShameLayers} from "../view/WalkOfShameLayers";
import {WalkOfShame} from "../WalkOfShame";
import {WalkOfShameSymbol} from "../symbol/WalkOfShameSymbol";
import {WalkOfShameGameMode} from "../server/WalkOfShameGameMode";
import {TimelineLite} from "gsap";
import {WalkOfShameHelper} from "../../core/utils/WalkOfShameHelper";
import {WalkOfShameSymbolState} from "../symbol/WalkOfShameSymbolConfig";
import {WalkOfShameSound} from "../sound/WalkOfShameSound";

export class StickyS2Overlay extends PIXI.spine.Spine {
    private _animName: string = "";
    private _tl: TimelineLite | null;

    constructor() {
        super(WalkOfShame.assetLoader.getSpineAsset("scatter2"));

        WalkOfShameLayers.getLayer(Layers.STICKY_S2)!.addChild(this);
        this.visible = false;
        this.x = 72;
    }

    public toggleS2(visible: boolean, symId: number): void {
        if (this.visible === visible) {
            return;
        }

        this.visible = visible;

        if (visible) {
            this.y = 162 + (symId * 148) + 74;

            this.updateTransform();
            WalkOfShame.reels[0].getSymbol(symId + 1).visible = false;
        } else {
            this.y = Number.MAX_VALUE;
            symId = (WalkOfShame.model.parsedGameData.s2SymId + 2);
            const symbol: WalkOfShameSymbol = WalkOfShame.reels[0].getSymbol(symId),
                replacedSymbol: WalkOfShameSymbol = symbol.replaceSymbol("S2", WalkOfShameSymbolState.NORMAL);

            if (this._animName) {
                WalkOfShameHelper.createTimelineForAnimation(replacedSymbol, 0, this._animName, false).timeScale(100);
            }

            this.state.clearTracks();
        }
    }

    public playS2Animation(name: string, loop: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        if (name !== "respin_trigger" && !this.visible) {
            return tl;
        }

        if (this._tl) {
            this._tl.pause();
            this._tl.kill();
            this._tl = null;
        }

        tl.add(() => {
            this.state.clearTracks();

            this._animName = name;
        });
        tl.add(this._tl = WalkOfShameHelper.createTimelineForAnimation(this, 0, name, loop));

        return tl;
    }

    public playXSplitAnimation(isWin: boolean): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let s2AnimName: string = (WalkOfShame.model.parsedGameData.mode.indexOf("RESPIN") > -1 ? "xsplit_respin" : "xsplit_norespin");

        if ((WalkOfShame.model.parsedGameData.mode === WalkOfShameGameMode.NORMAL || WalkOfShame.model.parsedGameData.mode === WalkOfShameGameMode.SUPER_FREESPIN) && (WalkOfShame.model.parsedGameData.nextMode.indexOf("RESPIN") > -1)) {
            s2AnimName = "xsplit_respin";
        }

        if (!this.visible) {
            tl.add(WalkOfShameHelper.createTimelineForAnimation(WalkOfShame.reels[0].getSymbol((WalkOfShame.model.parsedGameData.s2SymId + 1)), 0, s2AnimName, false));
        }

        tl.add([
            () => {
                WalkOfShameSound.soundPlayer.playTrack({
                    name: WalkOfShameSound.X_SPLIT_LIGHTER_SPARK.next()
                });

                WalkOfShameSound.soundPlayer.playTrack({
                    name: isWin ? WalkOfShameSound.X_SPLIT_WIN.next() : WalkOfShameSound.X_SPLIT_NO_WIN.next()
                });
            },
            this.playS2Animation(s2AnimName, false)
        ]);

        return tl;
    }
}